let timeBack = 10;
const handleF = () => {
  const target = document.querySelector("#ProductSelect-product-template"); 
  // console.log(target);
  if (target) {
    target.addEventListener("change", () => {
      setTimeout(() => {
        const urlParams = new URLSearchParams(new URL(window.location.href).search);
        const variantValue = urlParams.get("variant");

        const productInfoRow = target.closest(".product-info-row");
        const price_elem = productInfoRow ? productInfoRow.querySelector("[bss-b2b-variant-id]") : null;

        if (price_elem) {
          price_elem.removeAttribute("bss-b2b-product-active");

          setTimeout(() => {
            BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
          }, 100);
        }

        // BSS_B2B.cp.changeProductPrice(JSON.parse(document.querySelector('#bss-b2b-store-data').textContent), "[bss-b2b-variant-id]", false, false, target.value);
      }, 200);
    });
  } else if (timeBack-- > 0) {
    setTimeout(handleF, 300);
  }
};
handleF();


function handleChangeCpSearch() {
  const resultList = document.querySelector('#shopify-section-header-1 > div > div > div.header-row.header-row-1 > div > div.header-col-2.col-5 > div > div > form > input[type=text]:nth-child(4)');

  resultList.addEventListener('input', () => {
    setTimeout(()=>{
      BSS_B2B.changeProductPriceWithInterval()
    },2000)
  })
}

setTimeout(()=>{
  handleChangeCpSearch();
},1000)

if(window.location.pathname.includes('/collections/')){
  setTimeout(() => {
    
 const elms = document.querySelectorAll('select[name="id"]#ProductSelect-collection-template');
    if(elms.length){
      elms.forEach(item => {
        item.addEventListener("change", () => {
        let price_elemt = item.closest('.featured_product__item-body').querySelector('[bss-b2b-variant-id]');
              // console.log(item.value)
            if(price_elemt){
                price_elemt.removeAttribute('bss-b2b-product-active');
                
                setTimeout(() => {
                  BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
                }, 200)
            }
        })
      })
    }
  }, 300)
}


     $(document).ready(function () {
        if (BSS_B2B && window.location.pathname === '/cart') {
          if ($('.bss-checkout').length) {
            $("button[name='checkout']").prop('disabled', true);
          }
        }
        $('.for-Review').click(function () {
          $('#only--des').removeClass('active');
          $('#tabs-description').removeClass('active');
          $('#tab_review_tabbed').addClass('active');
          $('#tab-review').addClass('active');
          $('#shopify-product-reviews .spr-summary-actions .spr-summary-actions-newreview').trigger('click');
        });

        $(window).scroll(function () {
          // Check the scroll position
          var scroll = $(window).scrollTop();

          // Select the element to add the class to
          var $header = $('#header-style');

          // Define the scroll position at which the class should be added
          var scrollThreshold = 100; // Adjust this value to your needs

          // Add or remove the class based on the scroll position
          if (scroll >= scrollThreshold) {
            $header.addClass('custom--sticky');
          } else {
            $header.removeClass('custom--sticky');
          }
        });

        $('.quantity-controls-des').on('click', '.quantity-decrease', function () {
          var input = $(this).closest('.quantity-controls-des').next('input[type="number"]');
          var value = parseInt(input.val());
          if (value > 1) {
            input.val(value - 1);
          }
        });

        $('.quantity-controls').on('click', '.quantity-increase', function () {
          var input = $(this).closest('.quantity-controls').prev('input[type="number"]');
          var value = parseInt(input.val());
          input.val(value + 1);
        });

        if ($('#takeonebar').hasClass('custom-hide-sidebar')) {
          $('.custom-static-sidebar').addClass('custom-hide');
          $('body').addClass('custom-hide-sidebar');
        } else {
          $('.custom-static-sidebar').removeClass('custom-hide');
        }
        $('.closepop-now').click(function () {
          $('.scappfancybox-item .scappfancybox-close').trigger('click');
        });

          $('.add-to-cart').click(function (event) {
            event.preventDefault();

            var form = $(this).closest('.product-form');

            $('.add-to-cart').removeClass('cart-waiting');

            var selectedValue = form.find('.select-custm-new').val();
            if (!selectedValue) {
              form.find('.show-variable').show();
              $('.add-to-cart').removeClass('cart-waiting');
            } else {
              // console.log('Selected Value: ' + selectedValue);
            }
            setTimeout(function () {
              $('.add-to-cart').removeClass('cart-waiting');
            }, 1000);
            $('.add-to-cart').removeClass('cart-waiting');
          });

        try {
          var addToCartForms = document.querySelectorAll('.add-to-cart');

          addToCartForms.forEach(function (form) {
            form.addEventListener('click', function (event) {
              var quantityInput = jQuery(this + '.select-custm-new').val();

              alert(quantityInput);
              if (isNaN(quantityValue) || quantityValue === null) {
                alert('Please enter a valid quantity.');
              } else {
                alert(111);
                form.submit();
              }
            });
          });

          var addToCartButton = document.querySelector('#addToCartBtn');
          var selectElement = document.querySelector('.select-custm-new');
          var alertShown = false;

          addToCartButton.addEventListener('click', function (event) {
            if (!alertShown && selectElement.value === '') {
              event.preventDefault();
              $('.show-variable').show();
              // alert('Please select a variant before adding to cart.');
              alertShown = true;
            }
          });
          
          selectElement.addEventListener('change', function () {
            alertShown = false;
          });
        } catch (error) {
          
        }  
            var comparePrice = $('.price-compare');
            var regularPrice = $('.price-sale');
            var regularPrice1 = $('.price');
            var variantOptions = $('.product-variant-selector');
            var SKUid = $('#sku-display');

            if (variantOptions.length) {
              variantOptions.on('change', function () {
                var cPrice = $(this).find(':selected').attr('data-compare-price');
                var skuvalue = $(this).find(':selected').attr('data-sku');
                comparePrice.html(cPrice);
                //  SKUid.html(skuvalue);
                var rPrice = $(this).find(':selected').attr('data-regular-price');
                regularPrice.html(rPrice);
                regularPrice1.html(rPrice);
              });
            }


            if($('body').hasClass("custom-session-popup")){
              var is_modal_show = sessionStorage.getItem('alreadyShow');
              if(is_modal_show != 'alredy shown'){
                var currUrl = $(location).attr('href');
                  setTimeout (function () {
                      $('body').addClass("showPopup");
                    $('.popup-wrapper').addClass("cust--show");
                  }, 3000);
                  $(".closeNow").click(function(e){
                    e.preventDefault();
                    $('.popup-wrapper').removeClass("cust--show");
                    $('body').removeClass("showPopup");
                  });
                sessionStorage.setItem('alreadyShow','alredy shown');
              }
              else{
              }
              // console.log("found");
            }else{
            // console.log("Not found");
          }
    });


 

